// Single place that decides which backends this build talks to.
//
// Parcel inlines process.env.* at build time, so a production build with none
// of these set emits exactly the URLs that were previously hardcoded — the
// shipped desktop app and every existing browser keep working untouched.
//
// The local dev stack (docker-compose.dev.yml) serves everything from one
// origin through nginx, which is why these can all be same-origin paths there:
//
//   http://localhost:8080/          the IDE
//   http://localhost:8080/api       the Rails API
//   http://localhost:8080/hexi      the simulator build
//   http://localhost:8080/builder   the firmware build
//
// Same origin means no CORS locally at all.
//
// Production does the same for the API: the web image is built with
// SOULMATE_SERVER_URL=/api (see docker-compose.yml and images.yml) and nginx
// proxies that path to Rails on the editor vhost. A bare path also means the
// one bundle works from both editor. and www., which an absolute URL could
// not do.

// A configured value may be a bare path. Everything downstream feeds these to
// normalize-url, which rejects anything without an origin ("Invalid URL:
// /api/sketches/all"), so anchor paths to the page origin here rather than
// teaching every call site about relative URLs.
//
// Only the web build is ever configured with a path: the Electron build runs
// from file:// and has no useful origin, and its pipeline (`yarn
// build-electron`) sets none of these, so it keeps the absolute defaults.
const resolve = (url) =>
  url.startsWith("/") ? new URL(url, window.location.origin).href : url;

export const SERVER_URL = resolve(
  process.env.SOULMATE_SERVER_URL || "https://server.soulmatelights.com/"
);

export const EDITOR_URL = resolve(
  process.env.SOULMATE_EDITOR_URL || "https://editor.soulmatelights.com/"
);

export const SIMULATOR_URL = resolve(
  process.env.SOULMATE_SIMULATOR_URL || "https://build.soulmatelights.com/hexi"
);

export const FIRMWARE_URL = resolve(
  process.env.SOULMATE_FIRMWARE_URL ||
    "https://build.soulmatelights.com/builder"
);
